import * as Sentry from '@sentry/browser';

if ("production" == 'staging' || "production" == 'production') {
  Sentry.init({
    dsn: ""
  });
}
